import {useCallback} from 'react';
import type {CodelistRestrictor} from 'services/codelists';
import {useRestrictedCodelistsContext} from 'services/codelists';
import {useExpressionImportProps} from 'services/metadata/hooks/useExpressionImportProps';
import {getRestrictedExpressionCodelist} from '../functions';
import {useMemoizedCodelistRestrictor} from './useMemoizedCodelistRestrictor';

export const useExpressionCodelistRestrictor = (
  expressionId: string,
): CodelistRestrictor => {
  const importProps = useExpressionImportProps(expressionId);
  const {getRestrictedCodelist: getOuterRestrictedCodelist} =
    useRestrictedCodelistsContext();

  const restrict = useCallback<CodelistRestrictor>(
    codelist => {
      const outerCodelist = getOuterRestrictedCodelist(codelist);
      return getRestrictedExpressionCodelist(importProps, outerCodelist);
    },
    [getOuterRestrictedCodelist, importProps],
  );

  return useMemoizedCodelistRestrictor(restrict);
};
